export interface IEmailButton {
  label: string
  url: string
  type: 'button' | 'href'
}

export const IButtonType: Record<string, string> = { button: 'Button', href: 'Link' }
